import type { ReactNode } from "react";
import { Button } from "@/components/catalyst/Button";
import {
	Dialog,
	DialogActions,
	DialogBody,
	DialogTitle,
} from "@/components/catalyst/Dialog";
import {
	Table,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/catalyst/Table";

interface AppPartnersDialogLayoutProps {
	isOpen: boolean;
	onClose: () => void;
	children: ReactNode;
}

export function AppPartnersDialogLayout({
	isOpen,
	onClose,
	children,
}: AppPartnersDialogLayoutProps) {
	return (
		<Dialog open={isOpen} onClose={onClose} size="4xl">
			<DialogTitle>App Partners</DialogTitle>
			<DialogBody>
				<Table>
					<TableHead>
						<TableRow>
							<TableHeader>Name</TableHeader>
							<TableHeader>Status</TableHeader>
							<TableHeader>Manage</TableHeader>
						</TableRow>
					</TableHead>
					{children}
				</Table>
			</DialogBody>
			<DialogActions>
				<Button plain onClick={onClose}>
					Close
				</Button>
			</DialogActions>
		</Dialog>
	);
}
